import { convertGQLToProductJson } from 'utils/general';

/**
 * @info
 *
 * *The "store/product" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind product functionality.
 *
 * *This file*
 * This file outlines "mutations". Mutations are intended
 * to be as simple as possible. All modifications to the state
 * object should happen inside a mutation function. Each
 * of these functions must be synchronous. There should be nothing
 * that has a time delay, such as an AJAX request or a setTimeout.
 */

export default {
  setStatic(state, isStatic) {
    state.isStatic = isStatic;
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setNewProduct(state, newProduct) {
    if (state.isStatic) {
      state.product = newProduct;
      return;
    }
    const newMetafields = {
      general: {},
      banner: {},
      product_bundles: {},
      accentuate: {},
      cart_promo: {},
    };
    const mfs = newProduct.metafields?.filter((m) => m) || [];
    if (newProduct && mfs.length) {
      for (const [key, value] of Object.entries(newMetafields)) {
        mfs.forEach((element) => {
          if (key === element.namespace) {
            if (key === 'accentuate') {
              if (element.key === 'bundled_products') {
                newMetafields[element.namespace][element.key] = element.value;
              }
            } else {
              newMetafields[element.namespace][element.key] = element.value;
            }
          }
        });
      }
    }
    // Removes unwanted additional data
    if (newProduct && newProduct.description) {
      let descStr = newProduct.description;
      // Cleans all HTML tags
      descStr = descStr.replace(/(<([^>]+)>)/gi, '');
      // Removes data like `td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}`
      descStr = descStr.replace(/(td|br)(\s{)([^}]+)(})/gi, '');
      // Strips leading and trailing spaces
      newProduct.description = descStr.trim();
    }
    state.product = convertGQLToProductJson(newProduct);
    state.metafields = newMetafields;
  },
  setVariant(state, newVariant) {
    state.variant = { ...state.variant, ...newVariant };
  },
  setVariantImage(state, newImage) {
    state.variant.image = newImage;
  },
  setPrice(state, { price = '', compareAtPrice = '' }) {
    state.variant.price = price * 100;
    state.variant.compareAtPrice = compareAtPrice * 100;
  },
  setAvailable(state, newAvailable) {
    state.variant.available = newAvailable;
  },
  setOption(state, newOption) {
    state.variant.option = newOption;
  },
  setSku(state, newSku) {
    state.variant.sku = newSku;
  },
  setReviews(state, newReviews) {
    state.reviews.bottomline = newReviews.bottomline;
    state.reviews.reviews = newReviews.reviews;
    state.reviews.pagination = newReviews.pagination;
    state.reviews.loading = false;
  },
  setYMALLoading(state) {
    state.ymal.loading = true;
  },
  setYMAL(state, payload) {
    payload && payload.length && (state.ymal.payload = payload);
    state.ymal.loading = false;
  },
  setRVLoading(state) {
    state.rv.loading = true;
  },
  setRV(state, payload) {
    payload && payload.length && (state.rv.payload = payload);
    state.rv.loading = false;
  },
  setReviewResponse(state, code) {
    state.reviews.code = code;
  },
  showReviewForm(state) {
    state.reviews.writeReview = true;
  },
  setActiveCategory(state, payload) {
    state.activeCategory = payload;
  },
  setActiveImage(state, payload) {
    state.activeImage = payload;
  },
  setCustomSelected(state, payload) {
    state.customSelected = payload;
  },
  setSubscription(state, payload) {
    state.subscription = payload;
  },
  setShowingTryShade(state, payload) {
    state.showingTryShade = payload;
  }
};
